import React from 'react';
import { Box } from '@mui/material';
import CameraAltIcon from '@mui/icons-material/CameraAlt';

export interface PhotographerBadgeProps {
   /** When true, render as small overlay (e.g. on avatar corner). When false, render as inline chip/label. */
   variant?: 'avatarOverlay' | 'inline';
   size?: 'sm' | 'md';
}

export function PhotographerBadge({ variant = 'avatarOverlay', size = 'sm' }: PhotographerBadgeProps) {
   const isOverlay = variant === 'avatarOverlay';
   const iconSize = size === 'sm' ? 10 : 14;
   const overlayBox = isOverlay ? { position: 'absolute' as const, bottom: -2, right: -2 } : {};

   return (
      <Box
         sx={{
            ...overlayBox,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: isOverlay ? 14 : 22,
            height: isOverlay ? 14 : 22,
            borderRadius: '50%',
            bgcolor: '#00C4A7',
            color: 'white',
            border: '1.5px solid',
            borderColor: 'rgba(255,255,255,0.9)',
            boxShadow: '0 1px 2px rgba(0,0,0,0.3)',
         }}
         title="Photographer"
      >
         <CameraAltIcon sx={{ fontSize: iconSize }} />
      </Box>
   );
}
